<template>
  <a-modal
      :title="$t('contact_us.ContactUs')"
      @cancel="handleCloseModal"
      :visible="contactModal"
      :zIndex="1009">
    <CRow>
      <CCol sm="12">
        <CRow v-if="!isVendorInfoEmpty">
          <CCol md="12">
            <div class="info-box">
              <p v-if="infoBoxCustomMessage">{{infoBoxCustomMessage}}</p>
              <h3 v-else>{{infoBoxMessage}}</h3>
            </div>
          </CCol>
        </CRow>
        <Contacts />
      </CCol>
    </CRow>

    <template slot="footer">
      <footer class="d-flex justify-content-between">
        <a-button @click="handleCloseModal" class="ml-auto">{{ $t('Close') }}</a-button>
      </footer>
    </template>
  </a-modal>
</template>

<script>
import {EventBus} from "@/plugins/event-bus.js";
import Contacts from './Contacts'
import { ContactUsMixin } from "@/mixins/ContactUsMixin";
import { BusListenersMixin } from "@/mixins/BusListenersMixin";

export default {
  name: "TheContact",
  components: {
    Contacts,
  },
  mixins: [ContactUsMixin, BusListenersMixin],
  data() {
    return {
      contactModal: false,
      infoBoxMessage: `${this.$t('contact_us.contact_us_message')}:`,
      infoBoxCustomMessage: "",
    };
  },
  props: {},
  methods: {
    listenEvent() {
      this.subscribeBus(EventBus, "show-contact", (params) => {
        this.contactModal = true;
        if (params && params?.text) {
          this.infoBoxCustomMessage = params.text;
        }
      });
    },
    handleCloseModal() {
      this.contactModal = false;
    }
  },
  created() {
    this.listenEvent();
  }
};
</script>
